import React from 'react';
import './NovasAI.css';
import UnderConstructionNotice from '../components/UnderConstructionNotice.jsx';

export default function NovasCommunity() {
  return (
    <div className="novas-community-page">
      <UnderConstructionNotice
        section="Novas Community"
        message="A space for teachers to share lesson templates, swap teaching ideas, and connect with the wider NOVAS community is on the way. We will let you know as soon as it goes live."
      />
      <div className="novas-community-hero">
        <h1>Novas Community</h1>
        <p>Connect with other teachers, share templates, exchange tips. Coming soon.</p>
      </div>
    </div>
  );
}
